<template>
  <div class="footer flexCC" v-if="$store.state.isPc">
    <div class="centerWidth">
      <div class="fTop">
        <div class="top-item" v-for="item in topMes" :key="item.index">
          <img :src="item.imgsrc" alt="" />
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <el-divider />
    <div class="centerWidth">
      <div class="logo">
        <img :src="logosrc" />
      </div>
      <div class="fLeft">
        <div class="module" v-for="item in leftMes" :key="item.title">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="leftli" v-for="childI in item.child" :key="childI.name">
            {{ childI.name }}
          </div>
        </div>
      </div>
      <el-divider direction="vertical" class="vertial-divider" />
      <div class="fRight">
        <div class="module" v-for="item in rightMes" :key="item.title">
          <div class="title">
            {{ item.title }}
          </div>
          <div
            class="leftli"
            v-for="childItem in item.child"
            :key="childItem.name"
          >
            {{ childItem.name }}:{{ childItem.con }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="line centerWidth"></div> -->
    <el-divider />
    <div class="bottom centerWidth">
      <div class="botLeft">
        Copyright(&copy;)&nbsp;&nbsp;&nbsp;&nbsp;赛鸣科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;版权所有&nbsp;&nbsp;&nbsp;&nbsp;津ICP备16009197号-1
      </div>
      <div class="botRight">
        <div class="icon"></div>
        津公网安备 12019202000178号
      </div>
    </div>
  </div>
  <div class="mobile_footer" v-if="!$store.state.isPc">
    <div class="contenbox">
      <div class="fLeft">
        <!-- <div class="module" v-for="item in leftMes" :key="item.title">
                    <div class="title">
                        {{ item.title }}

                    </div>
                    <div class="leftli" v-for="childI in item.child" :key="childI.name">
                        {{ childI.name }}
                    </div>
                </div> -->
        <el-collapse accordion>
          <el-collapse-item
            v-for="item in leftMes"
            :key="item.title"
            :title="item.title"
            :name="item.index"
          >
            <div class="leftli" v-for="childI in item.child" :key="childI.name">
              {{ childI.name }}
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="fRight">
        <div class="module" v-for="item in rightMes" :key="item.title">
          <div
            class="leftli"
            v-for="childItem in item.child"
            :key="childItem.name"
          >
            {{ childItem.name }}:{{ childItem.con }}
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="botLeft">
        Copyright(&copy;)&nbsp;&nbsp;&nbsp;&nbsp;赛鸣科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;版权所有
      </div>
      <div>津ICP备16009197号-1</div>
      <div class="botRight">
        <div class="icon"></div>
        津公网安备 12019202000178号
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
const logosrc = require("@/assets/image/saiminglogo.png");
const topMes = reactive([
  {
    index: "1",
    imgsrc: require("@/assets/image/icon/footer1.png"),
    text: "7×24小时服务",
  },
  {
    index: "2",
    imgsrc: require("@/assets/image/icon/footer2.png"),
    text: "专业解决方案",
  },
  {
    index: "3",
    imgsrc: require("@/assets/image/icon/footer3.png"),
    text: "行业服务平台",
  },
  {
    index: "4",
    imgsrc: require("@/assets/image/icon/footer4.png"),
    text: "专家服务支持",
  },
]);

const leftMes = reactive([
  {
    index: "1",
    title: "优秀产品",
    child: [
      { name: "智慧型安全生产一体化管控平台" },
      { name: "数字化低代码开发平台" },
      { name: "线上线下一体化智慧零售平台" },
      { name: "智慧不动产资产管理平台" },
      { name: "线上教育培训平台" },
    ],
  },
  {
    index: "2",
    title: "解决方案",
    child: [
      { name: "数字化企业安全" },
      { name: "数字化企业运营" },
      { name: "数字化新零售" },
      { name: "数字化市政房产" },
      { name: "数字化人力资源" },
    ],
  },
  {
    index: "3",
    title: "关于我们",
    child: [
      {
        name: "关于赛鸣",
      },
      { name: "加入我们" },
    ],
  },
]);

const rightMes = reactive([
  {
    index: "1",
    title: "联系我们",
    child: [
      { name: "咨询电话", con: "022-83717958  18622474586" },
      { name: "商务合作", con: "smingtech@smingtech.com" },
      { name: "联系地址", con: "天津市华苑产业园区兰苑路5号A座四层" },
    ],
  },
]);
</script>

<style lang="scss" scoped>
@import "@/assets/css/public.scss";
::v-deep .el-divider--horizontal {
  margin: 0px;
  opacity: 0.1;
}
::v-deep .el-divider--vertical {
  margin: 20px 0px;
  opacity: 0.1;
  height: 85%;
}
.footer {
  height: 450px;
  background: #2e2e2e;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .fTop {
    padding-top: 10px;
    width: 100%;
    height: 80px;
    display: flex;
    font-size: 18px;
    .top-item {
      flex: 1;
      height: 80px;
      display: flex;
      justify-content: center;
      text-align: center;
      display: flex;
      align-items: center;
      img {
        margin-right: 20px;
      }
    }
  }

  .centerWidth {
    display: flex;
    justify-content: space-between;
    .logo {
      width: 150px;
      margin-top: 20px;
    }

    .fLeft {
      flex: 1;
      display: flex;
      justify-content: space-around;

      .module {
      }
    }
    .fRight {
      width: 350px;
      margin-left: 30px;
    }

    .module {
      .title {
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: bold;
        line-height: 35px;
        margin-top: 20px;
      }

      .leftli {
        font-family: Source Han Sans CN;
        font-size: 16px;
        line-height: 35px;
        opacity: 0.6;
      }
    }
  }

  .line {
    height: 1px;
    background: #a5b3be;
    margin-top: 20px;
  }

  .bottom {
    height: 30px;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    font-size: 14px;
    .botLeft {
      flex: 3;
      display: flex;
      justify-content: center;
    }
    .botRight {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      .icon {
        height: 18px;
        width: 18px;
        background: url("@/assets/image/icon/guohui.png");
        margin: 0 10px;
      }
    }
  }
}

.mobile_footer {
  // background: #F6F8FB;

  .contenbox {
    display: flex;
    flex-direction: column;

    .fLeft {
      font-size: 18px;
      padding: 0 10px;

      .leftli {
        border-bottom: 1px solid #f1f1f1;
        line-height: 50px;
        margin: 0 15px;
      }
      ::v-deep .el-collapse-item {
        color: #333 !important;
      }
      ::v-deep .el-collapse-item__header {
        font-size: 15px;
        border-bottom: 1px solid #f1f1f1;
      }
      ::v-deep .el-collapse-item__header.is-active {
        font-weight: bold;
      }
      ::v-deep .el-collapse-item__wrap {
        border: none;
      }
      ::v-deep .el-collapse-item__content {
        padding-bottom: 0;
      }
    }

    .fRight {
      font-size: 14px;
      line-height: 25px;
      margin-top: 10px;

      .module {
        display: flex;
        flex-direction: column;
        align-items: center;

        .leftli {
        }
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    align-items: center;
    line-height: 25px;
    margin-bottom: 20px;

    .botRight {
      display: flex;

      .icon {
        height: 18px;
        width: 18px;
        background: url("@/assets/image/icon/guohui.png");
        margin: 0 10px;
      }
    }
  }
}
</style>